import React from 'react';

import InvoiceService from '../../../../services/invoice/InvoiceService';
import DesignsService from '../../../../services/designs/DesignService';
import PaymentV2Service from '../../../../services/payment/PaymentV2Service';

interface IApiContext {
  invoiceApi: InvoiceService | null,
  designsApi: DesignsService | null,
  paymentsApi: PaymentV2Service | null,
}

const ApiContext = React.createContext<IApiContext>({
  invoiceApi: null,
  designsApi: null,
  paymentsApi: null,
});

export default ApiContext;
